/**
 * Auto-generated from .rsp.json by scripts/sync-prerender-routes.js — do not edit manually.
 */
export const PRERENDERED_ROUTES: readonly string[] = [
  "/",
  "/about",
  "/partners",
  "/legal",
  "/get-started",
  "/support",
  "/pitchplanet"
];

export function isPrerenderedRoute(pathname: string): boolean {
  const normalized = pathname.replace(/\/$/, "") || "/";
  return PRERENDERED_ROUTES.includes(normalized);
}
